import _styled from "@emotion/styled-base";
import { themed, mapComponentThemes } from "../themes";
import Popover from "../Popover";
import { tooltipTheme } from "./themes";
export var TooltipRoot = themed(Popover)(function (_ref) {
  var baseTheme = _ref.theme;
  return mapComponentThemes({
    name: 'Tooltip',
    theme: tooltipTheme(baseTheme)
  }, {
    name: 'Popover',
    theme: {}
  }, baseTheme);
});
export var TriggerText =
/*#__PURE__*/
_styled('span', {
  target: "e3ztgjb0"
})(function (_ref2) {
  var baseTheme = _ref2.theme;
  var theme = tooltipTheme(baseTheme);
  return {
    borderBottomStyle: theme.TooltipTriggerText_borderStyle,
    borderBottomColor: theme.TooltipTriggerText_borderColor,
    borderBottomWidth: theme.TooltipTriggerText_borderWidth
  };
});